import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { RecepcaoFisicaService } from 'src/app/services/clique-retire/recepcao-fisica/recepcao-fisica.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ExtratoImportacaoService } from 'src/app/services/clique-retire/extrato-importacao/extrato-importacao.service';
import { SelecionarExtratoImportacaoCabecalho, SelecionarExtratoImportacaoDetalhe } from 'src/app/@shared/models/extrato-importacao.model';

@Component({
  selector: 'app-modal-extrato-importacao',
  templateUrl: './modal-extrato-importacao.component.html',
  styleUrls: ['./modal-extrato-importacao.component.scss']
})

export class ModalExtratoImportacaoComponent implements OnInit {
  isLoading = true;
  paging = { index: 0, size: 5, length: 0 };
  loteId: number;
  importDetails: any;
  extracts: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'modelo',
    'codigo',
    'codigoBarra',
    'filial',
    'statusImportacao',
    'recepcaoFisica'
  ];

  constructor(
    public recepcaoFisicaService: RecepcaoFisicaService,
    private extratoImportacaoService: ExtratoImportacaoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) {
    if (data && (data !== null && data !== undefined)) {
      this.loteId = data;
      this.SelecionarExtratoImportacaoCabecalho();
    }
  }

  ngOnInit() { }

  SelecionarExtratoImportacaoCabecalho() {
    this.extratoImportacaoService.SelecionarExtratoImportacaoCabecalho(this.loteId)
      .subscribe(
        async (response: SelecionarExtratoImportacaoCabecalho) => {
          this.importDetails = response;
          await this.SelecionarExtratoImportacaoDetalhe();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar dados da Importação, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'warning-snackbar');
        });
  }

  async SelecionarExtratoImportacaoDetalhe() {
    this.isLoading = true;

    const obj = {
      LoteId: this.loteId,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    };

    this.extratoImportacaoService.SelecionarExtratoImportacaoDetalhe(obj)
      .subscribe(
        (response: HttpResponse<SelecionarExtratoImportacaoDetalhe[]>) => {
          this.extracts.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar dados da Improtação, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'warning-snackbar');
        });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.SelecionarExtratoImportacaoDetalhe();
  }

  totalContagemExtrato() {
    return Object.keys(this.extracts.data).length;
  }

  totalRecepcionado() {
    return this.extracts.data.filter(arr => !Object.values(arr).includes(null)).length;
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
